import { render } from "./logger-provider.vue?vue&type=template&id=049f8d30"
import script from "./logger-provider.vue?vue&type=script&lang=js"
export * from "./logger-provider.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__